import { render } from "./TabWithTable.vue?vue&type=template&id=185fce2f&scoped=true"
import script from "./TabWithTable.vue?vue&type=script&lang=js"
export * from "./TabWithTable.vue?vue&type=script&lang=js"

import "./TabWithTable.vue?vue&type=style&index=0&id=185fce2f&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185fce2f"]])

export default __exports__